<div *ngIf="option.emoji" class="icon">{{ option.emoji }}</div>
<div *ngIf="option.title && option.subtitle" class="d-flex flex-column ps-12 pe-12 text-container align-items-start justify-content-center">
    <div class="title">{{option.title}}</div>
    <div class="subtitle">{{option.subtitle}}</div>
</div>
<div *ngIf="option.imageFilePath" class="image" [ngStyle]="{ 'background-image': 'url(' + option.imageFilePath + ')' }"></div>
<canvas
    *ngIf="option.rive"
    #animation
    class="w-100" 
    width="480"
    [height]="480 / option.rive.ratio"
    >
</canvas>
<div *ngIf="option.title && !option.subtitle" class="title">{{ option.title }}</div>
